import { render } from "./entities-menu.vue?vue&type=template&id=1aa23c59&ts=true"
import script from "./entities-menu.component.ts?vue&type=script&lang=ts"
export * from "./entities-menu.component.ts?vue&type=script&lang=ts"

import exportComponent from "G:\\Projects\\Kml\\KmlAuth\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__